"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFormStatus;
var _react = _interopRequireDefault(require("react"));
function getFormStatus() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let styles = arguments.length > 1 ? arguments[1] : undefined;
  const form_status = [{
    label: 'info',
    suffix: '--green'
  }, {
    label: 'warning',
    suffix: '--orange'
  }, {
    label: 'error',
    suffix: '--red'
  }, {
    label: 'statement',
    suffix: '--blue'
  }];

  /**
   * Map all status from component.state and return information messages accordingly.
   *
   * @param    { Object }    status_data    Infos messages to display.
   * @param    { String }    index          Iteratof.
   *
   * @return    [Array]      Renderable React elements.
   */
  let status = form_status.filter(status_data => typeof state[status_data.label] !== 'undefined').map(function (status_data, index) {
    var message = /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: 'c-message ' + 'c-message' + status_data.suffix,
      styles: styles
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "c-message__content"
    }, state[status_data.label]));
    return message;
  });
  return status;
}
